// extracted by mini-css-extract-plugin
export var container = "_2s-0";
export var error = "_2s-9";
export var label = "_2s-5";
export var light = "_2s-6";
export var md = "_2s-3";
export var sm = "_2s-2";
export var thin = "_2s-8";
export var thinBold = "_2s-7";
export var vertical = "_2s-4";
export var xs = "_2s-1";